import Backbone from 'backbone'
import SnapType from '../snap-type'

const propByDirection = {
  left: {
    tl: 'left',
    bl: 'left',
    lm: 'left',
    tr: 'right',
    rm: 'right',
    br: 'right'
  },
  top: {
    tr: 'top',
    tl: 'top',
    tc: 'top',
    bc: 'bottom',
    bl: 'bottom',
    br: 'bottom'
  }
}

const GridSnap = SnapType.extend({

  initialize: function (opt) {
    this.types = [new VerticalGridSnap(opt), new HorizontalGridSnap(opt)]
  },

  snap: function (area, previousArea, handleType) {
    let difference = {}
    this.types.forEach(type => {
      difference = type.snap(area, difference, handleType)
    })
    return difference
  },

  // Don't call `.remove()` b/c it would remove the `el`, which is the canvas.
  release: () => {}

})

const GridSnapper = Backbone.View.extend({

  initialize: function (opt) {
    this.gridSize = opt.gridSize
  },

  snap: function (area, difference, handleType) {
    let prop = handleType ? propByDirection[this.direction][handleType] : this.direction // be sure to collect the keys before we shift below to ensure there will be an object

    if (handleType && !prop) {
      return difference
    }

    let snapTo = Math.round(area[prop] / this.gridSize) * this.gridSize

    difference[this.direction] = snapTo - area[prop]

    return difference
  }

})

const VerticalGridSnap = GridSnapper.extend({
  direction: 'left'
})

const HorizontalGridSnap = GridSnapper.extend({
  direction: 'top'
})

export default GridSnap
